var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"loader",staticClass:"loader"},[_c('div',{staticClass:"loader--logo"},_vm._l((_vm.logo),function(letter){return _c('p',{key:letter.id,ref:"letter",refInFor:true,staticClass:"loader--logo--letter"},[_vm._v("\n        "+_vm._s(letter)+"\n        ")])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc63ce44","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loader.vue
// module id = 44
// module chunks = 0